export default "__VITE_ASSET__CE7CMrI9__"